import { Link } from "react-router-dom";
import Logo from "@/components/layout/Logo";

const IMG = "https://images.unsplash.com/photo-1713110824336-f78c320dcf8e?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-[calc(100vh-4rem)] lg:grid-cols-2">
      <div className="flex items-center justify-center px-4 py-12 sm:px-8">
        <div className="w-full max-w-md">
          <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
          <p className="mt-2 text-slate-600">{subtitle}</p>
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-slate-600">{footer}</div>}
        </div>
      </div>
      <div className="relative hidden lg:block">
        <img src={IMG} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <Logo light />
          <p className="mt-4 max-w-md font-heading text-2xl font-semibold">Discover. Compare. Book.</p>
          <p className="mt-2 max-w-md text-white/80">Trusted local services across New Zealand, booked in minutes.</p>
        </div>
      </div>
    </div>
  );
}

export const AuthLink = ({ to, children, testId }) => <Link to={to} data-testid={testId} className="font-semibold text-sky-700 hover:underline">{children}</Link>;
